module.exports = __webpack_public_path__ + "img/IMG_8960.c7d1d70b.jpg";